import { useEffect, useMemo, useRef, useState } from 'react';
import './newContent.scss';
import RowLayoutPoster from '../../components/rowLayoutPoster/newRowLayoutPoster';
// import { getCookie } from '../../util/cookie';
import { useCustomTranslation } from '@/hooks/useCustomTranslation';
import { useHistory } from 'react-router-dom';
import { filterEmoji, JumpToActivityPage } from '../../util/util';
import If from '../../components/if/if';
import Event, { EVENTS } from '../../util/event';
import { report } from '../../util/dataReporting';
import { LGVChannelID } from '../../util/const';
import { getNextPageData } from '../newHome/getData';
import { performanceReport } from '../../util/playTimeReport';

function posterReport({
  curFocusPoster,
  modId,
  modPos,
  name,
  itemPos,
  attaId,
  elementId,
}) {
  let { cid = '' } = curFocusPoster;
  const { type, id = '' } = curFocusPoster;
  let pid = '';
  let jumpUrl = '';
  switch (type) {
    case 1:
      cid = cid || id || '';
      break;
    case 3:
      pid = id;
      break;
    case 5:
      jumpUrl = id;
      break;

    default:
      break;
  }
  report({
    attaId,
    element_id: elementId,
    mod_id: modId,
    mod_pos: modPos,
    mod_name: name,
    item_pos: itemPos,
    cid,
    vid: '',
    pid,
    jump_url: jumpUrl,
    main_cid: '',
    main_vid: '',
  });
}

export default function NewContent(props) {
  const {
    // isLeave,
    judgeCondition: {
      setIsHavePoster,
      setIsHaveHistory,
      setIsHaveFirstColumn,
      setIsHaveColumn,
    },
    // focusTemporaryBox,
  } = props;

  const isGetData = useMemo(() => props.isGetData, [props.isGetData]);
  const isNoData = useMemo(() => props.isNoData, [props.isNoData]);
  const isHome = useMemo(() => {
    const curFirstCategory = props?.curNavigation?.curNav?.channel?.user_choice?.first_category;
    return curFirstCategory && curFirstCategory !== 'All';
  }, [props?.curNavigation?.curNav?.channel?.user_choice?.first_category]);

  const poster = useMemo(() => props?.curNavigation?.poster || {}, [props?.curNavigation?.poster]);
  const history = useMemo(() => props?.curNavigation?.history || {}, [props?.curNavigation?.history]);
  const column = useMemo(() => props?.curNavigation?.column || [], [props?.curNavigation?.column]);

  const isHavePoster = useMemo(() => props.judgeCondition.isHavePoster, [props.judgeCondition.isHavePoster]);
  const isHaveHistory = useMemo(() => props.judgeCondition.isHaveHistory, [props.judgeCondition.isHaveHistory]);
  const isHaveFilter = useMemo(() => props.judgeCondition.isHaveFilter, [props.judgeCondition.isHaveFilter]);
  const isHaveNavigation = useMemo(() => (
    props.judgeCondition.isHaveNavigation
  ), [props.judgeCondition.isHaveNavigation]);
  const isHaveFirstColumn = useMemo(() => (
    props.judgeCondition.isHaveFirstColumn
  ), [props.judgeCondition.isHaveFirstColumn]);
  const isHaveColumn = useMemo(() => props.judgeCondition.isHaveColumn, [props.judgeCondition.isHaveColumn]);

  const columnAboveFilter = useMemo(() => (column && column[0]) || {}, [column]);
  const columnUnderFilter = useMemo(() => (column && column.slice(1)) || {}, [column]);

  useEffect(() => {
    setIsHavePoster(!!poster?.posterArr?.length);
  }, [poster]);

  useEffect(() => {
    setIsHaveHistory(!!history?.posterArr?.length);
  }, [history]);

  useEffect(() => {
    setIsHaveFirstColumn(!!columnAboveFilter?.posterArr?.length);
  }, [columnAboveFilter]);

  useEffect(() => {
    setIsHaveColumn(!!columnUnderFilter?.length);
  }, [columnUnderFilter]);

  return (
    <div className="newContent__navigation__down" style={{ display: isGetData || isNoData ? 'none' : 'block' }}>
      <div className="newContent">
        <If condition={isHavePoster}>
          <Poster
            isHome={isHome}
            poster={poster}
            headerflag={props.headerflag}
            setHeaderflag={props.setHeaderflag}
            isLeave={props.isLeave}
            judgeCondition={{
              isHavePoster,
              isHaveHistory,
              isHaveFilter,
              isHaveFirstColumn,
              isHaveColumn,
              isHaveNavigation,
            }}
          >
          </Poster>
        </If>
        <If condition={isHaveHistory}>
          <History
            isHome={isHome}
            history={history}
            headerflag={props.headerflag}
            setHeaderflag={props.setHeaderflag}
            isLeave={props.isLeave}
            judgeCondition={{
              isHavePoster,
              isHaveHistory,
              isHaveFilter,
              isHaveFirstColumn,
              isHaveColumn,
              isHaveNavigation,
            }}
          >
          </History>
        </If>
        <div className="module__content" id="module__content">
          <If condition={isHaveFirstColumn}>
            <FirstColumn
              columnAboveFilter={columnAboveFilter}
              headerflag={props.headerflag}
              setHeaderflag={props.setHeaderflag}
              moreTabJumpLink={props.moreTabJumpLink}
              isLeave={props.isLeave}
              judgeCondition={{
                isHavePoster,
                isHaveHistory,
                isHaveFilter,
                isHaveFirstColumn,
                isHaveColumn,
                isHaveNavigation,
              }}
            >
            </FirstColumn>
          </If>
          <If condition={isHaveFilter}>
            <EnterFilterPage
              headerflag={props.headerflag}
              moreTabJumpLink={props.moreTabJumpLink}
              setHeaderflag={props.setHeaderflag}
              isLeave={props.isLeave}
              judgeCondition={{
                isHavePoster,
                isHaveHistory,
                isHaveFilter,
                isHaveFirstColumn,
                isHaveColumn,
                isHaveNavigation,
              }}
            />
          </If>
          <If condition={isHaveColumn}>
            <VirtualLists
              columnUnderFilter={columnUnderFilter}
              headerflag={props.headerflag}
              moreTabJumpLink={props.moreTabJumpLink}
              setHeaderflag={props.setHeaderflag}
              isLeave={props.isLeave}
              judgeCondition={{
                isHavePoster,
                isHaveHistory,
                isHaveFilter,
                isHaveFirstColumn,
                isHaveColumn,
                isHaveNavigation,
              }}
              nextPageData={props.nextPageData}
            >
            </VirtualLists>
          </If>
        </div>
      </div>
    </div>
  );
}

let filterShankTimer;
function EnterFilterPage(props) {
  const jumpHistory = useHistory();
  const scrollIntoView = () => {
    const doc = document.querySelector('#first__module');
    const navigationTop = document.querySelector('#navigation').offsetHeight;
    const scrollY = doc?.offsetTop - navigationTop - 30;
    window.scrollTo(0, scrollY);
  };
  // 是否是LG
  const vchannelId = localStorage.getItem('v_channel_id');
  const isLG = !!LGVChannelID.includes(vchannelId);
  const { t } = useCustomTranslation();
  // filter组件数据
  const filterPageBtnArr = [
    {
      name: '最热',
      sort: '2',
    },
    {
      name: '最新',
      sort: '1',
    },
    {
      name: '全部',
      sort: '0',
    },
  ];
  // 当前模块是否聚焦
  const isChecked = useMemo(() => props.headerflag === 6, [props.headerflag]);
  const isCheckedRef = useRef(isChecked);
  useEffect(() => {
    isCheckedRef.current = isChecked;
  }, [isChecked]);

  useEffect(() => {
    if (isChecked && !props.isLeave) {
      scrollIntoView();
    }
  }, [isChecked, props.isLeave]);
  // 当前聚焦的位置
  const [curFocusIdx, setCurFocusIdx] = useState(0);
  const curFocusIdxRef = useRef(curFocusIdx);
  useEffect(() => {
    curFocusIdxRef.current = curFocusIdx;
  }, [curFocusIdx]);

  // 要跳转的地址
  const moreTabJumpLink = useMemo(() => props.moreTabJumpLink, [props.moreTabJumpLink]);
  const moreTabJumpLinkRef = useRef(props.moreTabJumpLink);
  useEffect(() => {
    moreTabJumpLinkRef.current = moreTabJumpLink;
  }, [moreTabJumpLink]);

  const jumpLink = useRef('');
  useEffect(() => {
    const defaultLink = isLG ? '/filterPageLG/0' : '/filterPage/0';
    const countLink = `${props.moreTabJumpLink}/${filterPageBtnArr[curFocusIdx].sort}`;
    jumpLink.current = curFocusIdx === 2 ? defaultLink : countLink;
  }, [moreTabJumpLink, curFocusIdx]);

  // 五个状态，判断上下切换开始
  const isHavePosterRef = useRef(props.judgeCondition.isHavePoster);
  const isHaveHistoryRef = useRef(props.judgeCondition.isHaveHistory);
  const isHaveFilterRef = useRef(props.judgeCondition.isHaveFilter);
  const isHaveFirstColumnRef = useRef(props.judgeCondition.isHaveFirstColumn);
  const isHaveColumnRef = useRef(props.judgeCondition.isHaveColumn);
  const isHaveNavigationRef = useRef(props.judgeCondition.isHaveNavigation);

  useEffect(() => {
    isHavePosterRef.current = props.judgeCondition.isHavePoster;
  }, [props.judgeCondition.isHavePoster]);
  useEffect(() => {
    isHaveHistoryRef.current = props.judgeCondition.isHaveHistory;
  }, [props.judgeCondition.isHaveHistory]);
  useEffect(() => {
    isHaveFilterRef.current = props.judgeCondition.isHaveFilter;
  }, [props.judgeCondition.isHaveFilter]);
  useEffect(() => {
    isHaveFirstColumnRef.current = props.judgeCondition.isHaveFirstColumn;
  }, [props.judgeCondition.isHaveFirstColumn]);
  useEffect(() => {
    isHaveColumnRef.current = props.judgeCondition.isHaveColumn;
  }, [props.judgeCondition.isHaveColumn]);
  useEffect(() => {
    isHaveNavigationRef.current = props.judgeCondition.isHaveNavigation;
  }, [props.judgeCondition.isHaveNavigation]);
  // 五个状态，判断上下切换结束
  const [shankIdx, setShankIdx] = useState(-1);

  // 移除抖动函数
  const removeShank = () => {
    setShankIdx(-1);
    clearTimeout(filterShankTimer);
  };
  // 添加抖动
  const shankFunc = (index) => {
    setShankIdx(index);
    if (filterShankTimer) {
      clearTimeout(filterShankTimer);
    }
    filterShankTimer = setTimeout(() => {
      removeShank();
    }, 2000);
  };

  const moveLeft = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current > 0) {
      setCurFocusIdx(curFocusIdx => curFocusIdx - 1);
    } else {
      removeShank();
      shankFunc(0);
    }
  };
  const moveRight = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current < 2) {
      setCurFocusIdx(curFocusIdx => curFocusIdx + 1);
    } else {
      removeShank();
      shankFunc(2);
    }
  };
  const moveUp = () => {
    if (!isCheckedRef.current) return;
    if (isHaveFirstColumnRef.current) {
      props.setHeaderflag(5);
    } else if (isHaveHistoryRef.current) {
      props.setHeaderflag(4);
    } else if (isHavePosterRef.current) {
      props.setHeaderflag(3);
    } else if (isHaveNavigationRef.current) {
      props.setHeaderflag(2);
    } else {
      props.setHeaderflag(1);
    }
  };
  const moveDown = () => {
    if (!isCheckedRef.current) return;
    if (isHaveColumnRef.current) {
      props.setHeaderflag(7);
    } else {
      props.setHeaderflag(8);
    }
  };
  const moveClick = () => {
    if (!isCheckedRef.current) return;
    jumpHistory.push(jumpLink.current);
  };

  useEffect(() => {
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
    return () => {
      clearTimeout(filterShankTimer);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
    };
  }, []);

  function mouseClick(e, curFocusIdx) {
    if (curFocusIdxRef.current === curFocusIdx && isCheckedRef.current) {
      moveClick();
      return;
    }
    e && e.stopPropagation && e.stopPropagation();
    setCurFocusIdx(curFocusIdx);
    curFocusIdxRef.current = curFocusIdx;
    Event.emit(EVENTS.HOME_UPDATE_STATE, {
      headerflag: 6,
    });
  }

  return (
    <div
      className='enter__filterPage__content'
    >
      {filterPageBtnArr.map((item, index) => (
        <div
          style={{ display: 'inline-block' }}
          key={index}
          className={
            [
              shankIdx === index ? 'enter__fliterPage__Btn__shank' : null,
              'enter__fliterPage__Btn',
              isChecked && curFocusIdx === index ? 'focusable' : '',
            ].join(' ')}
          onClick={e => mouseClick(e, index)}
        >
          {t(item.name)}
        </div>
      ))}
    </div>
  );
}

function Poster(props) {
  const jumpHistory = useHistory();

  const isChecked = useMemo(() => props.headerflag === 3, [props.headerflag]);
  const isCheckedRef = useRef(isChecked);
  useEffect(() => {
    isCheckedRef.current = isChecked;
  }, [isChecked]);

  useEffect(() => {
    if (isChecked && !props.isLeave) {
      window.scrollTo(0, 0);
    }
  }, [isChecked, props.isLeave]);

  const [curFocusIdx, setCurFocusIdx] = useState(0);
  const curFocusIdxRef = useRef(curFocusIdx);
  useEffect(() => {
    curFocusIdxRef.current = curFocusIdx;
  }, [curFocusIdx]);

  // 五个状态，判断上下切换开始
  const isHavePosterRef = useRef(props.judgeCondition.isHavePoster);
  const isHaveHistoryRef = useRef(props.judgeCondition.isHaveHistory);
  const isHaveFilterRef = useRef(props.judgeCondition.isHaveFilter);
  const isHaveFirstColumnRef = useRef(props.judgeCondition.isHaveFirstColumn);
  const isHaveColumnRef = useRef(props.judgeCondition.isHaveColumn);

  useEffect(() => {
    isHavePosterRef.current = props.judgeCondition.isHavePoster;
  }, [props.judgeCondition.isHavePoster]);
  useEffect(() => {
    isHaveHistoryRef.current = props.judgeCondition.isHaveHistory;
  }, [props.judgeCondition.isHaveHistory]);
  useEffect(() => {
    isHaveFilterRef.current = props.judgeCondition.isHaveFilter;
  }, [props.judgeCondition.isHaveFilter]);
  useEffect(() => {
    isHaveFirstColumnRef.current = props.judgeCondition.isHaveFirstColumn;
  }, [props.judgeCondition.isHaveFirstColumn]);
  useEffect(() => {
    isHaveColumnRef.current = props.judgeCondition.isHaveColumn;
  }, [props.judgeCondition.isHaveColumn]);
  // 五个状态，判断上下切换结束

  const isHome = useMemo(() => props.isHome, [props.isHome]);
  const posterArr = useMemo(() => props.poster.posterArr, [props.poster.posterArr]);
  const moduleName = useMemo(() => props.poster.moduleName, [props.poster.moduleName]);
  const posterAction = useMemo(() => props.poster.posterAction, [props.poster.posterAction]);
  const posterWidth = useMemo(() => props.poster.posterWidth, [props.poster.posterWidth]);
  const posterHeight = useMemo(() => props.poster.posterHeight, [props.poster.posterHeight]);
  useEffect(() => {
    setCurFocusIdx(0);
  }, [props.poster.posterArr]);

  const posterLength = useRef(posterArr?.length);

  const curFocusPosterRef = useRef({});
  useEffect(() => {
    curFocusPosterRef.current = (posterArr && posterArr[curFocusIdx]) || {};
  }, [curFocusIdx, posterArr]);

  const curColumnInfoRef = useRef({});
  useEffect(() => {
    const { mod_id: modId, mod_pos: modPos, name } = props.poster;
    curColumnInfoRef.current = { modId, modPos, name };
  }, [props.poster]);

  useEffect(() => {
    posterLength.current = posterArr?.length || 0;
    if (posterArr?.length) {
      const { mod_id: modId = '', mod_pos: modPos = 0, name = '' } = curColumnInfoRef.current;
      posterArr.forEach((poster, index) => {
        posterReport({
          curFocusPoster: poster,
          modId,
          modPos,
          name,
          itemPos: index,
          attaId: '02d00063512',
          elementId: 'linuxtv_channel',
        });
      });
    }
  }, [posterArr]);

  const moveLeft = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current > 0) {
      setCurFocusIdx(curFocusIdxRef.current - 1);
    }
  };
  const moveRight = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current < posterLength.current - 1) {
      setCurFocusIdx(curFocusIdxRef.current + 1);
    }
  };
  const moveUp = () => {
    if (!isCheckedRef.current) return;
    props.setHeaderflag(2);
  };
  const moveDown = () => {
    if (!isCheckedRef.current) return;
    if (isHaveHistoryRef.current) {
      props.setHeaderflag(4);
    } else if (isHaveFirstColumnRef.current) {
      props.setHeaderflag(5);
    } else if (isHaveFilterRef.current) {
      props.setHeaderflag(6);
    } else if (isHaveColumnRef.current) {
      props.setHeaderflag(7);
    } else {
      props.setHeaderflag(8);
    }
  };
  const moveClick = () => {
    if (!isCheckedRef.current) return;
    const { modId = '', modPos = 0, name = '' } = curColumnInfoRef;
    const { id = '', type } = curFocusPosterRef.current;
    posterReport({
      curFocusPoster: curFocusPosterRef.current,
      modId,
      modPos,
      name,
      itemPos: curFocusIdxRef.current,
      attaId: '06b00063513',
      elementId: 'linuxtv_channel',
    });
    // 点击海报跳转逻辑新增
    if (JumpToActivityPage(curFocusPosterRef.current)) return;
    if (id && id.substring(0, 4) === 'http') {
      jumpHistory.push('/Activity');
    } else if (type === 3) {
      jumpHistory.push(`/LiveStreamingFull/${id}`);
    } else {
      // 点击开始计时，用于统计跳转耗时
      jumpHistory.push(`/particular/${id}/homepage`);
      performanceReport.recordTimePoint('jump_start_time');
    }
  };

  useEffect(() => {
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
    return () => {
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
    };
  }, []);


  function mouseClick(e, curFocusIdx) {
    if (curFocusIdxRef.current === curFocusIdx && isCheckedRef.current) {
      moveClick();
      return;
    }
    e && e.stopPropagation && e.stopPropagation();
    setCurFocusIdx(curFocusIdx);
    curFocusIdxRef.current = curFocusIdx;
    Event.emit(EVENTS.HOME_UPDATE_STATE, {
      headerflag: 3,
    });
  }

  return (
    <div
      className={[
        'poster',
        isHome ? 'posterOther' : 'posterHome',
      ].join(' ')}
      id="poster"
    >
      {posterArr?.length ? (
        <div style={{ height: `${posterHeight / global.constants.rootValue}rem` }}>
          <RowLayoutPoster
            // 是否选中当行
            isChecked={isChecked}
            // 改行海报数据
            posterArr={posterArr}
            // 模块名称
            moduleIdx={moduleName}
            // 当前模块聚焦位置
            focusIndex={curFocusIdx}
            // 抖动海报索引
            actionIdx={posterAction}
            // 海报尺寸
            posterWidth={posterWidth}
            mouseClick={mouseClick}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

function History(props) {
  const jumpHistory = useHistory();

  const isChecked = useMemo(() => props.headerflag === 4, [props.headerflag]);
  const isCheckedRef = useRef(isChecked);
  useEffect(() => {
    isCheckedRef.current = isChecked;
  }, [isChecked]);

  useEffect(() => {
    if (isChecked && !props.isLeave) {
      window.scrollTo(0, 0);
    }
  }, [isChecked, props.isLeave]);

  const [curFocusIdx, setCurFocusIdx] = useState(0);
  const curFocusIdxRef = useRef(curFocusIdx);
  useEffect(() => {
    curFocusIdxRef.current = curFocusIdx;
  }, [curFocusIdx]);

  const isHome = useMemo(() => props.isHome, [props.isHome]);

  // 五个状态，判断上下切换开始
  const isHavePosterRef = useRef(props.judgeCondition.isHavePoster);
  const isHaveHistoryRef = useRef(props.judgeCondition.isHaveHistory);
  const isHaveFilterRef = useRef(props.judgeCondition.isHaveFilter);
  const isHaveFirstColumnRef = useRef(props.judgeCondition.isHaveFirstColumn);
  const isHaveColumnRef = useRef(props.judgeCondition.isHaveColumn);

  useEffect(() => {
    isHavePosterRef.current = props.judgeCondition.isHavePoster;
  }, [props.judgeCondition.isHavePoster]);
  useEffect(() => {
    isHaveHistoryRef.current = props.judgeCondition.isHaveHistory;
  }, [props.judgeCondition.isHaveHistory]);
  useEffect(() => {
    isHaveFilterRef.current = props.judgeCondition.isHaveFilter;
  }, [props.judgeCondition.isHaveFilter]);
  useEffect(() => {
    isHaveFirstColumnRef.current = props.judgeCondition.isHaveFirstColumn;
  }, [props.judgeCondition.isHaveFirstColumn]);
  useEffect(() => {
    isHaveColumnRef.current = props.judgeCondition.isHaveColumn;
  }, [props.judgeCondition.isHaveColumn]);
  // 五个状态，判断上下切换结束

  const posterArr = useMemo(() => props.history.posterArr, [props.history.posterArr]);
  const moduleName = useMemo(() => props.history.moduleName, [props.history.moduleName]);
  const posterAction = useMemo(() => props.history.posterAction, [props.history.posterAction]);
  const posterWidth = useMemo(() => props.history.posterWidth, [props.history.posterWidth]);
  const posterHeight = useMemo(() => props.history.posterHeight, [props.history.posterHeight]);
  useEffect(() => {
    setCurFocusIdx(0);
  }, [props.history.posterArr]);
  const posterLength = useRef(posterArr?.length);

  const curFocusPosterRef = useRef({});
  useEffect(() => {
    curFocusPosterRef.current = (posterArr && posterArr[curFocusIdx]) || {};
  }, [curFocusIdx, posterArr]);

  const curColumnInfoRef = useRef({});
  useEffect(() => {
    const { mod_id: modId, mod_pos: modPos, name } = props.history;
    curColumnInfoRef.current = { modId, modPos, name };
  }, [props.history]);

  useEffect(() => {
    posterLength.current = posterArr?.length || 0;
    if (posterArr?.length) {
      const { mod_id: modId = '', mod_pos: modPos = 0, name = '' } = curColumnInfoRef.current;
      posterArr.forEach((poster, index) => {
        if (poster.posterType !== 6) {
          posterReport({
            curFocusPoster: poster,
            modId,
            modPos,
            name,
            itemPos: index,
            attaId: '02d00063512',
            elementId: 'linuxtv_channel',
          });
        }
      });
    }
  }, [posterArr]);

  const moveLeft = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current > 0) {
      setCurFocusIdx(curFocusIdxRef.current - 1);
    }
  };
  const moveRight = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current < posterLength.current - 1) {
      setCurFocusIdx(curFocusIdxRef.current + 1);
    }
  };
  const moveUp = () => {
    if (!isCheckedRef.current) return;
    if (isHavePosterRef.current) {
      props.setHeaderflag(3);
    } else {
      props.setHeaderflag(2);
    }
  };
  const moveDown = () => {
    if (!isCheckedRef.current) return;
    if (isHaveFirstColumnRef.current) {
      props.setHeaderflag(5);
    } else if (isHaveFilterRef.current) {
      props.setHeaderflag(6);
    } else if (isHaveColumnRef.current) {
      props.setHeaderflag(7);
    } else {
      props.setHeaderflag(8);
    }
  };
  const moveClick = () => {
    if (!isCheckedRef.current) return;
    const { modId = '', modPos = 0, name = '' } = curColumnInfoRef;
    const { id = '', posterType, type } = curFocusPosterRef.current;
    if (posterType === 6) {
      report({
        attaId: '0e600058578',
        scene: 'linuxtv_homepage',
        module: 'history',
        button: 'history',
      });
    } else {
      posterReport({
        curFocusPoster: curFocusPosterRef.current,
        modId,
        modPos,
        name,
        itemPos: curFocusIdxRef.current,
        attaId: '06b00063513',
        elementId: 'linuxtv_channel',
      });
    }
    // 点击海报跳转逻辑新增
    if (JumpToActivityPage(curFocusPosterRef.current)) return;
    if (!id) {
      jumpHistory.push('/watchHistory/');
    } else if (id && id.substring(0, 4) === 'http') {
      jumpHistory.push('/Activity');
    } else if (type === 3) {
      jumpHistory.push(`/LiveStreamingFull/${id}`);
    } else {
      jumpHistory.push(`/particular/${id}/homepage`);
    }
  };

  useEffect(() => {
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
    return () => {
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
    };
  }, []);

  function mouseClick(e, curFocusIdx) {
    if (curFocusIdxRef.current === curFocusIdx && isCheckedRef.current) {
      moveClick();
      return;
    }
    e && e.stopPropagation && e.stopPropagation();
    setCurFocusIdx(curFocusIdx);
    curFocusIdxRef.current = curFocusIdx;
    Event.emit(EVENTS.HOME_UPDATE_STATE, {
      headerflag: 4,
    });
  }

  return (
    <div
      className={[
        'history',
        isHome ? 'historyForOther' : 'historyForHome',
      ].join(' ')}
      id="history"
    >
      {posterArr?.length ? (
        <div style={{ height: `${posterHeight / global.constants.rootValue}rem` }}>
          <RowLayoutPoster
            // 是否选中该行
            isChecked={isChecked}
            // 该行海报数据
            posterArr={posterArr}
            // 模块名称
            moduleIdx={moduleName}
            // 海报聚焦索引
            focusIndex={curFocusIdx}
            // 海报抖动索引
            actionIdx={posterAction}
            // 海报尺寸
            posterWidth={posterWidth}
            // 是否有历史记录
            isHaveHistory={true}
            // 是否有更多按钮
            addBtnPosition={'left'}
            mouseClick={mouseClick}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

function FirstColumn(props) {
  const jumpHistory = useHistory();

  const timer = useRef(null);

  const scrollIntoView = () => {
    const doc = document.querySelector('#first__module');
    const navigationTop = document.querySelector('#navigation').offsetHeight;
    const scrollY = doc?.offsetTop - navigationTop - 30;
    window.scrollTo(0, scrollY);
  };

  const isChecked = useMemo(() => props.headerflag === 5, [props.headerflag]);
  const isCheckedRef = useRef(isChecked);
  useEffect(() => {
    isCheckedRef.current = isChecked;
  }, [isChecked]);

  useEffect(() => {
    if (isChecked && !props.isLeave) {
      scrollIntoView();
    }
  }, [isChecked, props.isLeave]);

  const [curFocusIdx, setCurFocusIdx] = useState(0);
  const curFocusIdxRef = useRef(curFocusIdx);
  useEffect(() => {
    curFocusIdxRef.current = curFocusIdx;
  }, [curFocusIdx]);

  // 五个状态，判断上下切换开始
  const isHavePosterRef = useRef(props.judgeCondition.isHavePoster);
  const isHaveHistoryRef = useRef(props.judgeCondition.isHaveHistory);
  const isHaveFilterRef = useRef(props.judgeCondition.isHaveFilter);
  const isHaveFirstColumnRef = useRef(props.judgeCondition.isHaveFirstColumn);
  const isHaveColumnRef = useRef(props.judgeCondition.isHaveColumn);

  useEffect(() => {
    isHavePosterRef.current = props.judgeCondition.isHavePoster;
  }, [props.judgeCondition.isHavePoster]);
  useEffect(() => {
    isHaveHistoryRef.current = props.judgeCondition.isHaveHistory;
  }, [props.judgeCondition.isHaveHistory]);
  useEffect(() => {
    isHaveFilterRef.current = props.judgeCondition.isHaveFilter;
  }, [props.judgeCondition.isHaveFilter]);
  useEffect(() => {
    isHaveFirstColumnRef.current = props.judgeCondition.isHaveFirstColumn;
  }, [props.judgeCondition.isHaveFirstColumn]);
  useEffect(() => {
    isHaveColumnRef.current = props.judgeCondition.isHaveColumn;
  }, [props.judgeCondition.isHaveColumn]);
  // 五个状态，判断上下切换结束

  const posterArr = useMemo(() => props.columnAboveFilter.posterArr, [props.columnAboveFilter.posterArr]);
  const name = useMemo(() => props.columnAboveFilter.name, [props.columnAboveFilter.name]);
  const posterAction = useMemo(() => props.columnAboveFilter.posterAction, [props.columnAboveFilter.posterAction]);
  const posterWidth = useMemo(() => props.columnAboveFilter.posterWidth, [props.columnAboveFilter.posterWidth]);
  const posterHeight = useMemo(() => props.columnAboveFilter.posterHeight, [props.columnAboveFilter.posterHeight]);
  const moduleIdx = useMemo(() => props.columnAboveFilter.moduleIdx, [props.columnAboveFilter.moduleIdx]);
  useEffect(() => {
    setCurFocusIdx(0);
  }, [props.columnAboveFilter.posterArr]);

  const curFocusPosterRef = useRef({});
  useEffect(() => {
    curFocusPosterRef.current = (posterArr && posterArr[curFocusIdx]) || {};
  }, [curFocusIdx, posterArr]);

  const curColumnInfoRef = useRef({});
  useEffect(() => {
    const { mod_id: modId, mod_pos: modPos, name } = props.columnAboveFilter;
    curColumnInfoRef.current = { modId, modPos, name };
  }, [props.columnAboveFilter]);

  const posterLength = useRef(posterArr?.length);
  useEffect(() => {
    posterLength.current = posterArr?.length || 0;
    if (posterArr?.length) {
      const { mod_id: modId = '', mod_pos: modPos = 0, name = '' } = curColumnInfoRef.current;
      posterArr.forEach((poster, index) => {
        if (poster.posterType !== 6) {
          posterReport({
            curFocusPoster: poster,
            modId,
            modPos,
            name,
            itemPos: index,
            attaId: '02d00063512',
            elementId: 'linuxtv_channel',
          });
        }
      });
    }
  }, [posterArr]);

  const moreTabJumpLinkRef = useRef(props.moreTabJumpLink);
  useEffect(() => {
    moreTabJumpLinkRef.current = props.moreTabJumpLink;
  }, [props.moreTabJumpLink]);

  const moveLeft = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current > 0) {
      setCurFocusIdx(curFocusIdxRef.current - 1);
    }
  };
  const moveRight = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current < posterLength.current - 1) {
      setCurFocusIdx(curFocusIdxRef.current + 1);
    }
  };
  const moveUp = () => {
    if (!isCheckedRef.current) return;
    if (isHaveHistoryRef.current) {
      props.setHeaderflag(4);
    } else if (isHavePosterRef.current) {
      props.setHeaderflag(3);
    } else {
      props.setHeaderflag(2);
    }
  };
  const moveDown = () => {
    if (!isCheckedRef.current) return;
    if (isHaveFilterRef.current) {
      props.setHeaderflag(6);
    } else if (isHaveColumnRef.current) {
      props.setHeaderflag(7);
    } else {
      props.setHeaderflag(8);
    }
  };
  const moveClick = () => {
    if (!isCheckedRef.current) return;
    const { modId = '', modPos = 0, name = '' } = curColumnInfoRef.current;
    const { id = '', type } = curFocusPosterRef.current;
    // 点击更多跳转逻辑
    if (!id) {
      if (moreTabJumpLinkRef.current) {
        jumpHistory.push(moreTabJumpLinkRef.current);
      }
      return;
    }
    posterReport({
      curFocusPoster: curFocusPosterRef.current,
      modId,
      modPos,
      name,
      itemPos: curFocusIdxRef.current,
      attaId: '06b00063513',
      elementId: 'linuxtv_channel',
    });
    // 点击海报跳转逻辑新增
    if (JumpToActivityPage(curFocusPosterRef.current)) return;
    if (type === 3) {
      jumpHistory.push(`/LiveStreamingFull/${id}`);
    } else {
      jumpHistory.push(`/particular/${id}/homepage`);
    }
  };

  useEffect(() => {
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
    return () => {
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
    };
  }, []);


  function mouseClick(e, curFocusIdx) {
    if (curFocusIdxRef.current === curFocusIdx && isCheckedRef.current) {
      moveClick();
      return;
    }
    e && e.stopPropagation && e.stopPropagation();
    setCurFocusIdx(curFocusIdx);
    curFocusIdxRef.current = curFocusIdx;
    Event.emit(EVENTS.HOME_UPDATE_STATE, {
      headerflag: 5,
    });
  }

  useEffect(() => (
    () => {
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
    }
  ), []);

  function mouseOver(e, type) {
    e && e.stopPropagation && e.stopPropagation();
    if (!isCheckedRef.current) {
      Event.emit(EVENTS.HOME_UPDATE_STATE, {
        headerflag: 5,
      });
    };
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    timer.current = setTimeout(() => {
      if (type === 'before') {
        moveLeft();
      } else if (type === 'after') {
        moveRight();
      }
      mouseOver(e, type);
    }, 300);
  }

  function mouseOut(e) {
    e && e.stopPropagation && e.stopPropagation();
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
  }

  return (
    <div className='module__item' key={name} id="first__module">
      <div
        className='module__item__before'
        onMouseOver={e => mouseOver(e, 'before')}
        onMouseOut={e => mouseOut(e)}
      >
      </div>
      <h5 className='column__title'>{filterEmoji(name || '')}</h5>
      <div style={{ height: `${posterHeight / global.constants.rootValue}rem` }}>
        <RowLayoutPoster
          isChecked={isChecked}
          posterArr={posterArr}
          moduleIdx={moduleIdx}
          focusIndex={curFocusIdx}
          isHaveMore={posterArr?.length > 4}
          actionIdx={posterAction}
          posterWidth={posterWidth}
          // 当前聚焦位置
          headerflag={props.headerflag}
          mouseClick={mouseClick}
        >
        </RowLayoutPoster>
      </div>
      <div
        className='module__item__after'
        onMouseOver={e => mouseOver(e, 'after')}
        onMouseOut={e => mouseOut(e)}
      >
      </div>
    </div>
  );
}

let isRequest = false;
function VirtualLists(props) {
  const timer = useRef(null);
  const jumpHistory = useHistory();
  const scrollIntoView = () => {
    const doc = document.querySelector('#virtualLists');
    const footerDoc = document.querySelector('#footer__homePage');
    const navigationTop = document.querySelector('#navigation').offsetHeight;
    const documHeight = document.documentElement.clientHeight;
    const scrollY = curFocusColumnIdxRef.current > 1
      ? footerDoc?.offsetTop - documHeight + 30
      : doc?.offsetTop - navigationTop - 30;
    window.scrollTo(0, scrollY);
  };
  // 是否有filter组件
  const isHaveFilterRef = useRef(props.judgeCondition.isHaveFilter);
  useEffect(() => {
    isHaveFilterRef.current = props.judgeCondition.isHaveFilter;
  }, [props.judgeCondition.isHaveFilter]);
  // // 该组件展示的海报内容
  const [column, setColumn] = useState(props.columnUnderFilter);
  useEffect(() => {
    setFocusInfoArr([]);
    setColumn(props.columnUnderFilter);
  }, [props.columnUnderFilter]);
  // const column = useMemo(() => props.columnUnderFilter, [props.columnUnderFilter]);
  const nextPageDataRef = useRef(props.nextPageData);
  useEffect(() => {
    nextPageDataRef.current = props.nextPageData;
  }, [props.nextPageData]);

  // 是否聚焦在虚拟列表这个组件
  const isChecked = useMemo(() => props.headerflag === 7, [props.headerflag]);
  const isCheckedRef = useRef(isChecked);
  useEffect(() => {
    isCheckedRef.current = isChecked;
  }, [isChecked]);

  // 每一行聚焦的位置
  const [focusInfoArr, setFocusInfoArr] = useState([]);
  const focusInfoArrRef = useRef(focusInfoArr?.length);
  useEffect(() => {
    focusInfoArrRef.current = focusInfoArr;
  }, [focusInfoArr]);

  // 该组件展示的分页数组
  const [columnUnderFilterArr, setColumnUnderFilterArr] = useState([]);

  // 当前选中的channel，目前所加载的column分页信息(一页三行)，将展示的内容进行分页
  useEffect(() => {
    const curColumn = column || [];
    const columnArr = [];
    let curPageIdx = 0;
    const pageSize = 3;
    let curPageArr = [];
    for (let index = 0; index < curColumn.length; index++) {
      if (curPageIdx * pageSize <= index && index < (curPageIdx + 1) * pageSize) {
        curPageArr.push(curColumn[index]);
      } else {
        columnArr.push(curPageArr);
        curPageIdx += 1;
        curPageArr = [curColumn[index]];
      }
      if (index === curColumn.length - 1) {
        columnArr.push(curPageArr);
      }
    }
    setColumnUnderFilterArr(columnArr);
    const length = curColumn.length - focusInfoArrRef.current?.length;
    const addArr = Array(length).fill(0);
    // 每一行对应一个聚焦位置，更新focusInfoArr值保存每一行的聚焦位置
    setFocusInfoArr((focusInfoArr) => {
      // eslint-disable-next-line
      focusInfoArr = [...focusInfoArr, ...addArr];
      return focusInfoArr;
    });
  }, [column]);

  // 分页数组总共有多少页
  const pageLenRef = useRef(columnUnderFilterArr.length);
  useEffect(() => {
    pageLenRef.current = columnUnderFilterArr.length;
  }, [columnUnderFilterArr]);

  // 当前聚焦在第几页信息
  const [curColumnPage, setCurColumnPage] = useState(0);
  const curColumnPageRef = useRef(curColumnPage);
  useEffect(() => {
    curColumnPageRef.current = curColumnPage;
  }, [curColumnPage]);

  // 根据第几页信息计算出当前页展示的数据
  const curPageColumn = useMemo(() => columnUnderFilterArr[curColumnPage] || [], [columnUnderFilterArr, curColumnPage]);
  const curPageColumnRef = useRef(curPageColumn);
  useEffect(() => {
    curPageColumnRef.current = curPageColumn;
  }, [curPageColumn]);

  useEffect(() => {
    if (curPageColumn?.length) {
      curPageColumn.forEach((column, index) => {
        const idx = curColumnPageRef.current * 3 + index;
        const { modId = '', modPos = idx + 1, name = '' } = column;
        if (column?.posterArr?.length) {
          column.posterArr.forEach((poster, idx) => {
            const { id } = poster;
            if (id) {
              posterReport({
                curFocusPoster: poster,
                modId,
                modPos,
                name,
                itemPos: idx,
                attaId: '02d00063512',
                elementId: 'linuxtv_channel',
              });
            }
          });
        }
      });
    }
  }, [curPageColumn]);

  // 当前聚焦在第几行信息
  const [curFocusColumnIdx, setCurFocusColumnIdx] = useState(0);
  const curFocusColumnIdxRef = useRef(curFocusColumnIdx);
  useEffect(() => {
    curFocusColumnIdxRef.current = curFocusColumnIdx;
    if (isCheckedRef.current) {
      scrollIntoView();
    }
  }, [curFocusColumnIdx]);

  useEffect(() => {
    if (isChecked && !props.isLeave) {
      scrollIntoView();
    }
  }, [isChecked, props.isLeave]);

  // 根据当前页展示的数据以及第几行信息计算出当前聚焦行的数据
  const [curFocusColumnData, setCurFocusColumnData] = useState(0);
  const curFocusColumnDataRef = useRef(curFocusColumnData);
  useEffect(() => {
    setCurFocusColumnData(curPageColumn[curFocusColumnIdx] || {});
    curFocusColumnDataRef.current = curPageColumn[curFocusColumnIdx] || {};
  }, [curFocusColumnIdx, curPageColumn]);

  // 更多点击时跳转路径
  const moreTabJumpLinkRef = useRef(props.moreTabJumpLink);
  useEffect(() => {
    moreTabJumpLinkRef.current = props.moreTabJumpLink;
  }, [props.moreTabJumpLink]);

  // // 当前聚焦column的索引值
  // const curColumnFocusIndex =
  // useMemo(() => curColumnPage * 3 + curFocusColumnIdx, [curColumnPage, curFocusColumnIdx]);
  // const getFocusIdx

  // 更新下一页数据
  const updateNextPageData = () => {
    if (isRequest) return;
    isRequest = true;
    const { channelId, pageCtx, hasNextPage } = nextPageDataRef.current;
    if (hasNextPage) {
      getNextPageData({
        channelId,
        pageCtx,
      }).then((result) => {
        if (result) {
          const { pageCtx, hasNextPage, column } = result;
          nextPageDataRef.current = {
            ...nextPageDataRef.current,
            pageCtx,
            hasNextPage,
          };
          setColumn(columnArr => ([...columnArr, ...column]));
        }
        isRequest = false;
      });
    }
  };

  // 左移
  const moveLeft = () => {
    if (!isCheckedRef.current) return;
    const idx = curColumnPageRef.current * 3 + curFocusColumnIdxRef.current;
    setFocusInfoArr((focusInfoArr) => {
      const curFocusIdx = focusInfoArr[idx];
      // eslint-disable-next-line
      focusInfoArr[idx] = curFocusIdx > 0 ? curFocusIdx - 1 : 0;
      return [...focusInfoArr];
    });
  };
  // 右移
  const moveRight = () => {
    if (!isCheckedRef.current) return;
    const idx = curColumnPageRef.current * 3 + curFocusColumnIdxRef.current;
    const curFocusColPosterLen = curFocusColumnDataRef.current?.posterArr?.length || 0;
    setFocusInfoArr((focusInfoArr) => {
      const curFocusIdx = focusInfoArr[idx];
      // eslint-disable-next-line
      focusInfoArr[idx] = curFocusIdx < curFocusColPosterLen - 1 ? curFocusIdx + 1 : curFocusColPosterLen - 1;
      return [...focusInfoArr];
    });
  };
  // 上移
  const moveUp = () => {
    if (!isCheckedRef.current) return;
    if (curFocusColumnIdxRef.current > 0) {
      setCurFocusColumnIdx(curFocusColumnIdx => curFocusColumnIdx - 1);
    } else if (curColumnPageRef.current > 0) {
      setCurColumnPage(curColumnPage => curColumnPage - 1);
      setCurFocusColumnIdx(2);
    } else if (isHaveFilterRef.current) {
      props.setHeaderflag(6);
    } else {
      props.setHeaderflag(5);
    }
  };
  // 下移
  const moveDown = () => {
    if (!isCheckedRef.current) return;
    if (nextPageDataRef.current.hasNextPage && !isRequest) {
      updateNextPageData();
    }
    if (curFocusColumnIdxRef.current < curPageColumnRef.current.length - 1) {
      setCurFocusColumnIdx(curFocusColumnIdx => curFocusColumnIdx + 1);
    } else if (curColumnPageRef.current < pageLenRef.current - 1) {
      setCurColumnPage(curColumnPage => curColumnPage + 1);
      setCurFocusColumnIdx(0);
      // updateNextPageData();
    } else {
      if (nextPageDataRef.current.hasNextPage) {
        // updateNextPageData();
      } else {
        props.setHeaderflag(8);
      }
    }
  };
  // 点击
  const moveClick = () => {
    if (!isCheckedRef.current) return;
    const idx = curColumnPageRef.current * 3 + curFocusColumnIdxRef.current;
    const curColumnInfo = curFocusColumnDataRef.current;
    const { modId = '', modPos = idx + 1, name = '' } = curColumnInfo;
    const curColumnFocusIdx = focusInfoArrRef.current[idx];
    const curFocusPoster = curColumnInfo?.posterArr[curColumnFocusIdx];
    const { id, type } = curFocusPoster;
    if (!id) {
      if (moreTabJumpLinkRef.current) {
        jumpHistory.push(moreTabJumpLinkRef.current);
      }
      return;
    };
    posterReport({
      curFocusPoster,
      modId,
      modPos,
      name,
      itemPos: curColumnFocusIdx,
      attaId: '06b00063513',
      elementId: 'linuxtv_channel',
    });
    // 点击海报跳转逻辑新增
    if (JumpToActivityPage(curFocusPoster)) return;
    if (type === 3) {
      jumpHistory.push(`/LiveStreamingFull/${id}`);
    } else {
      jumpHistory.push(`/particular/${id}/homepage`);
    }
  };

  const homePageReturnTop = () => {
    window.scrollTo(0, 0);
    setCurColumnPage(0);
    setCurFocusColumnIdx(0);
  };

  useEffect(() => {
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
    Event.on(EVENTS.HOME_PAGE_RETURN_TOP, homePageReturnTop);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_EXIT, homePageReturnTop);
    return () => {
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
      Event.off(EVENTS.HOME_PAGE_RETURN_TOP, homePageReturnTop);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_EXIT, homePageReturnTop);
    };
  }, []);

  function mouseClick(e, curFocusIdx, curFocusColumnIdx) {
    const idx = curColumnPageRef.current * 3 + curFocusColumnIdx;
    if (isCheckedRef.current
      && curFocusColumnIdxRef.current === curFocusColumnIdx
      && focusInfoArrRef.current[idx] === curFocusIdx) {
      moveClick();
      return;
    }
    e && e.stopPropagation && e.stopPropagation();
    setCurFocusColumnIdx(curFocusColumnIdx);
    curFocusColumnIdxRef.current = curFocusColumnIdx;
    setFocusInfoArr((focusInfoArr) => {
      // eslint-disable-next-line
      focusInfoArr[idx] = curFocusIdx;
      return [...focusInfoArr];
    });
    Event.emit(EVENTS.HOME_UPDATE_STATE, {
      headerflag: 7,
    });
  }

  useEffect(() => (
    () => {
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
    }
  ), []);

  function mouseOver(e, type, index) {
    e && e.stopPropagation && e.stopPropagation();
    if (!isCheckedRef.current) {
      Event.emit(EVENTS.HOME_UPDATE_STATE, {
        headerflag: 7,
      });
    };
    (index || index === 0) && setCurFocusColumnIdx(index);
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    timer.current = setTimeout(() => {
      if (type === 'before') {
        moveLeft();
      } else if (type === 'after') {
        moveRight();
      }
      mouseOver(e, type);
    }, 300);
  }

  function mouseOut(e) {
    e && e.stopPropagation && e.stopPropagation();
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
  }

  return (
    <div id="virtualLists">
      {curPageColumn.map((columnItem, index) => (
        <div className='module__item' key={columnItem?.name}>
          <div
            className='module__item__before'
            onMouseOver={e => mouseOver(e, 'before', index)}
            onMouseOut={e => mouseOut(e)}
          >
          </div>
          <h5 className='column__title'>{filterEmoji(columnItem?.name || '')}</h5>
          <div
            style={{ height: `${columnItem?.posterHeight / global.constants.rootValue}rem` }}
          >
            <RowLayoutPoster
              curFocusColumnIdx={index}
              isChecked={isChecked && curFocusColumnIdx === index}
              posterArr={columnItem?.posterArr}
              moduleIdx={columnItem?.moduleIdx}
              focusIndex={focusInfoArr[curColumnPage * 3 + index] || 0}
              actionIdx={columnItem?.posterAction}
              isHaveMore={columnItem?.posterArr.length > 4}
              posterWidth={columnItem?.posterWidth}
              // 当前聚焦位置
              headerflag={props.headerflag}
              mouseClick={mouseClick}
            >
            </RowLayoutPoster>
          </div>
          <div
            className='module__item__after'
            onMouseOver={e => mouseOver(e, 'after', index)}
            onMouseOut={e => mouseOut(e)}
          >
          </div>
        </div>
      ))}
    </div>
  );
}
